export interface RGB {
  r: number;
  g: number;
  b: number;
}

export enum ColourType {
  Light = 1,
  Dark,
}

export function hexToRgb(hex: string): RGB {
  // Remove '#' if present
  let cleanHex = hex.match(/^#.*/) ? hex.slice(1) : hex;

  // Handle 3-digit shorthand hex codes (e.g., #fff -> #ffffff)
  if (cleanHex.length === 3) {
    cleanHex = cleanHex.split('').map(char => char + char).join('');
  }

  // Parse the individual color components
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);

  // Return the RGB string
  return { r, g, b};
}

export function colourType({ r, g, b }: RGB): ColourType {
  const sum = r + g + b;
  const mid = 255 * 3 / 2;
  
  if (sum > mid) {
    return ColourType.Light;
  }

  return ColourType.Dark;
}

export function inverseRgb({ rgb, emphasise = false}: {rgb: RGB, emphasise?: boolean}) {
  const type = colourType(rgb);
  let incr = 0;
  if (emphasise) {
    incr = 25;
  } else {
    incr = -25;
  }

  if (type === ColourType.Dark) {
    return {r: 205 + incr, g: 205 + incr, b: 205 + incr };
  }
  return {r: 50 - incr, g: 50 - incr, b: 50 - incr };
}

export function rgbToString({ r, g, b }: RGB): string {
  return `rgba(${r}, ${g}, ${b}, 1)`;
}